/**
 * Trigger: tr_creditors_update
 * Purpose: Update account balances when creditor details change
 * Table: creditors
 * Event: UPDATE OF account_id, currency_id, creditor_date, amount, exchange_rate
 */
export const TR_CREDITORS_UPDATE = `
CREATE TRIGGER tr_creditors_update
UPDATE OF account_id, currency_id, creditor_date, amount, exchange_rate ON creditors
BEGIN
  UPDATE account_balances
  SET creditors_amount = creditors_amount - old.amount
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET creditors_amount = creditors_amount - old.amount
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.creditor_date;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.creditor_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.creditor_date);

  UPDATE account_balances
  SET creditors_amount = creditors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET creditors_amount = creditors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.creditor_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.creditor_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
